<div class="horizontalMenucontainer">
    <div class="app-header header sticky">
        <div class="d-flex align-items-center justify-content-center w-100">
            <a class="header-brand">
              <img src="../assets/images/brand/ic_logo.svg" class="header-brand-img">
            </a>
          </div>
    </div>       
    <div class="bodyContainer">
        <router-outlet><app-loader></app-loader></router-outlet>
    </div>
  </div>
  <app-tab-to-top></app-tab-to-top>
  